import { Organization } from 'types';
import APIClient from './APIClient';
import type { LocalIntelligenceLot } from 'types/LocalIntelligenceLot';

class OrganizationService {
    getOrganization(id: number | string, token: string): Promise<Organization> {
        return APIClient.get(`organizations/${id}/`, token);
    }

    getOrganizations(token: string): Promise<{ name: string; pk: number }[]> {
        return APIClient.get(`organizations/`, token);
    }

    getOrganizationLots(organizationId: string, token: string): Promise<LocalIntelligenceLot[]> {
        return APIClient.get(`organizations/${organizationId}/lots/`, token);
    }
}

export default new OrganizationService();
